/* globals sliderData */
import EventEmitter from 'events'
import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

export default class ScrollAnimations extends EventEmitter {
  constructor(el) {
    super()
    this.scrollAnimationTargets = document.querySelectorAll('.js-scrollAnimationTarget')
  }
  init() {
    // console.log('\u001b[32m' + 'ScrollAnimationsInit' + '\u001b[0m')
      
    this.scrollAnimationTargets.forEach((target) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: target,
          start: 'top bottom',
          end: 'bottom top',
          scrub: false,
          // markers: true,
        },
      })
      tl.fromTo(target, {
        opacity: 0
        }, {
          duration: 1,
          opacity: 1
        }
      )
    });
  }
}
